export const APPS = [
  {
    id: 'cadet-pilot',
    aliases: ['aeropace'], // keeps /aeropace/* links (registered with the App Store) working
    name: 'Cadet Pilot',
    fullName: 'Cadet Pilot: Aptitude Test',
    orientation: 'landscape',
    tint: '#5ac8fa',
    category: { en: 'Aviation Training', tr: 'Havacılık Eğitimi' },
    headline: { en: 'Train for real aviation exams.', tr: 'Gerçek havacılık sınavlarına hazırlanın.' },
    art: {
      desktop: '/images/app-cards/cadet-a-desktop.png',
      desktopWebp: '/images/app-cards/cadet-a-desktop.webp',
      mobile: '/images/app-cards/cadet-a-mobile.png',
      mobileWebp: '/images/app-cards/cadet-a-mobile.webp',
    },
    icon: '/images/aweropace.png',
    appStore: 'https://apps.apple.com/tr/app/cadet-pilot-psikometrik-test/id6762213265',
    instagram: 'https://www.instagram.com/cadetpilotapp/',
    googlePlay: 'https://play.google.com/store/apps/details?id=com.onyxup.pace&pcampaignid=web_share',
    subtitle: { en: 'Aviation exams & psychomotor practice', tr: 'Havacılık sınavları & psikomotor pratik' },
    short:
      'Prepare for aviation selection and licensing-style assessments with structured simulations and drills that build coordination, attention, and confidence.',
    description: {
      en: [
        'Cadet Pilot: Aptitude Test helps pilots and candidates prepare with simulations inspired by aviation selection and licensing workflows. Practice timed tasks, hand-eye coordination scenarios, and structured exercises designed to build confidence before the real assessment — not to replace official testing.',
        'Train on your own device, track your progress over time, and revisit weak areas at your pace.',
      ],
      tr: [
        'Cadet Pilot: Aptitude Test, havacılık seçim ve lisanslama süreçlerinden esinlenen simülasyonlarla pilotların ve adayların hazırlanmasına yardımcı olur. Zamanlı görevler, el-göz koordinasyonu senaryoları ve gerçek değerlendirmeden önce güven kazandırmak için tasarlanmış yapılandırılmış alıştırmalarla pratik yapın — resmi testlerin yerini almaz.',
        'Kendi cihazınızda antrenman yapın, ilerlemenizi zaman içinde takip edin ve zayıf olduğunuz alanlara kendi hızınızda geri dönün.',
      ],
    },
    strip: null, // no verified rating/age/version metadata yet
    // Real local screenshots — used on the detail page.
    screenshots: Array.from({ length: 14 }, (_, i) => `/images/cadet-ss/${String(i + 1).padStart(2, '0')}.png`),
    // Hero preview: local screenshots, theme-aware (see HeroFan.jsx).
    heroScreenshotsDark: [
      '/images/home-cadet-prev/cadet-dark-1.PNG',
      '/images/home-cadet-prev/cadet-dark-2.PNG',
      '/images/home-cadet-prev/cadet-dark-3.PNG',
      '/images/home-cadet-prev/cadet-dark-4.PNG',
    ],
    heroScreenshotsLight: [
      '/images/home-cadet-prev/cadet-light-1.PNG',
      '/images/home-cadet-prev/cadet-light-2.PNG',
      '/images/home-cadet-prev/cadet-light-3.PNG',
      '/images/home-cadet-prev/cadet-light-4.PNG',
    ],
  },
  {
    id: 'social-fridge-magnets',
    aliases: [],
    name: 'Social Fridge Magnets',
    fullName: 'Social Fridge Magnets',
    orientation: 'portrait',
    tint: '#ff6b9a',
    category: { en: 'Social', tr: 'Sosyal' },
    headline: { en: 'Share memories on your fridge.', tr: 'Anılarınızı buzdolabınızda paylaşın.' },
    art: {
      desktop: '/images/app-cards/fridge-a-desktop.png',
      mobile: '/images/app-cards/fridge-a-mobile.png',
      mobileWebp: '/images/app-cards/fridge-a-mobile.webp',
    },
    icon: '/images/social-fridge-logo.png',
    appStore: null, // ← not published yet, replace with the real App Store link
    instagram: null,
    googlePlay: null, // ← not published yet, replace with the real Play Store link
    subtitle: { en: 'Turn your photos into shareable fridge magnets', tr: 'Fotoğraflarınızı paylaşılabilir buzdolabı magnetlerine çevirin' },
    short:
      'Decorate your favorite photos with 100+ magnet and sticker styles, organize them into shared boards, and swap memories with friends and family.',
    description: {
      en: [
        'Social Fridge Magnets turns your favorite photos into playful virtual magnets, stickers, and decorations for your own digital fridge. Choose from 100+ magnet and sticker styles, decorate your memories exactly how you like, then create shared boards to swap photos with friends and family — just like the fridge in your kitchen, but everywhere you go.',
        'When someone adds a new magnet, everyone on the shared board sees it instantly — shopping reminders, birthday notes, holiday photos, all on the same familiar door.',
      ],
      tr: [
        'Social Fridge Magnets, en sevdiğiniz fotoğrafları kendi dijital buzdolabınız için eğlenceli sanal magnetlere, çıkartmalara ve süslemelere dönüştürür. 100\'den fazla magnet ve çıkartma stili arasından seçim yapın, anılarınızı tam istediğiniz gibi süsleyin, ardından arkadaşlarınız ve ailenizle fotoğraf paylaşmak için ortak panolar oluşturun — mutfağınızdaki buzdolabı gibi, ama her yerde.',
        'Biri yeni bir magnet eklediğinde, ortak pano üzerindeki herkes anında görür — alışveriş hatırlatmaları, doğum günü notları, tatil fotoğrafları, hepsi aynı tanıdık kapıda.',
      ],
    },
    strip: null,
    // Real local screenshots — used on both the detail page and the hero preview.
    screenshots: Array.from({ length: 8 }, (_, i) => `/images/fridge-ss/${String(i + 1).padStart(2, '0')}.png`),
  },
  {
    id: 'habit-branches',
    aliases: [],
    name: 'Habit Branches',
    fullName: 'Habit Branches: New Year Goal & Habit Tracker',
    orientation: 'portrait',
    tint: '#4ade80',
    category: { en: 'Productivity', tr: 'Üretkenlik' },
    headline: { en: 'New Year Goal & Habit Tracker', tr: 'Yeni Yıl Hedef & Alışkanlık Takibi' },
    art: null, // no dedicated card art yet — AppCard falls back to a tinted gradient
    icon: '/images/habitbranches.png',
    appStore: null, // ← not published yet, replace with the real App Store link
    instagram: null,
    googlePlay: null,
    hideGooglePlay: true, // iOS-only app, never shipping on Google Play
    subtitle: { en: 'New Year goals & daily habit tracker', tr: 'Yeni yıl hedefleri & günlük alışkanlık takibi' },
    short:
      'Turn your New Year goals into daily habits, grow a branching tree as you stay consistent, and track streaks that actually keep you motivated.',
    description: {
      en: [
        'Habit Branches turns your New Year goals into small daily habits you can actually keep. Every day you stay consistent, a new branch grows on your tree — a visual, satisfying way to watch your progress build up over the year instead of losing track after a few weeks.',
        'Set up goals and daily habits, track streaks, and see your tree grow right on your device — all your data stays local, with nothing to sign in or sync.',
      ],
      tr: [
        'Habit Branches, yeni yıl hedeflerinizi gerçekten sürdürebileceğiniz küçük günlük alışkanlıklara dönüştürür. Düzenli kaldığınız her gün ağacınıza yeni bir dal eklenir — yılın birkaç haftasında motivasyonu kaybetmek yerine ilerlemenizi görsel ve tatmin edici şekilde izlemenizi sağlar.',
        'Hedefler ve günlük alışkanlıklar oluşturun, serilerinizi takip edin ve ağacınızın cihazınızda büyüdüğünü görün — tüm verileriniz cihazınızda kalır, giriş yapmanıza veya senkronize etmenize gerek yoktur.',
      ],
    },
    strip: null,
    // Real local screenshots — used on the detail page.
    screenshots: Array.from({ length: 6 }, (_, i) => `/images/habitbranches-ss/HabitBranches-iPhone-${String(i + 1).padStart(2, '0')}.png`),
  },
];

export const byId = (id) => APPS.find((a) => a.id === id || a.aliases.includes(id));
